import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonComponent } from './button';
import { ButtonVariant, ButtonType } from './button.type';

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent]
})
class ButtonModule {}

export { ButtonModule, ButtonVariant, ButtonType };
